import React, {Component} from 'react';
import {connect} from 'react-redux';
import Auxiliary from '../Auxiliary/Auxiliary';
import classes from './layout.module.css';
import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import SideDrawer from '../../components/Navigation/SideDrawer/SideDrawer';
//import DrawerToggle from '../Navigation/DrawerToggle/DrawerToggle';


//lect vid 149 - converting function const to class due to click listener
class Layout extends Component {
    state = {
        showSideDrawer: true,
       // drawerToggleChanger: true
    }
    sideDrawerClsHndlr = () => {
        this.setState({showSideDrawer: false});
    }
    //mine -skipping over for now
      /*       drawerToggleMover = () => {
                this.setState({drawerToggleChanger: false});
                this.setState({showSideDrawer: false});
            } */
    sideDrawerToggleHndlr = () => {
        this.setState((prevState) => {
         return {showSideDrawer: !prevState.showSideDrawer};
        });
    }

 /*            drawerToggleClicked = () => {

            } */
    render() {
        return (
    <Auxiliary> 
    {/* <div>Side Drawer, Toolbar, Backdrop </div> */}
    <Toolbar
    isAuth={this.props.isAuthenticated}
    drawerToggleClicked={this.sideDrawerToggleHndlr} />
    <SideDrawer 
    isAuth={this.props.isAuthenticated}
    open={this.state.showSideDrawer}
     closed={this.sideDrawerClsHndlr}
     />
    <main className={classes.Content}>
        {this.props.children}
    </main>
    </Auxiliary> 
        );
    }
}  

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null
    };
};


export default connect(mapStateToProps, null)(Layout) ;